import { render } from "./photoCapture.vue?vue&type=template&id=707c8ce8&scoped=true"
import script from "./photoCapture.vue?vue&type=script&lang=js"
export * from "./photoCapture.vue?vue&type=script&lang=js"

import "./photoCapture.vue?vue&type=style&index=0&id=707c8ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707c8ce8"]])

export default __exports__